const ROLE_VALUES = ['OWNER', 'RESIDENT', 'RENTER'];
const STRUCTURE_VALUES = ['HO', 'CO', 'TH'];

export class ValidateUtility {

  static isLocation(input) {

    // Validate Input
    if (!input) return false

    // Validate Address
    const address = [
      'tumbonPrefix',
      'tumbonName',
      'amphurPrefix',
      'amphurName',
      'provinceName',
      'zipCode',
    ].map(e => input[e])

    return address.every(e => !!e)
  }

  // Form inputs arrive as '' when cleared, API/Excel values as null or undefined
  static isEmpty(input) {
    return input == null || input === ''
  }

  static isArea(input) {

    // Number('') is 0, so empty input must be rejected up front
    if (ValidateUtility.isEmpty(input)) return false

    const area = Number(input)

    return (
      Number.isFinite(area) && area >= 1 && area <= 2000
    )
  }

  static isRole(input) {
    return ROLE_VALUES.includes(input)
  }

  static isStructure(input) {
    return STRUCTURE_VALUES.includes(input)
  }

  static isDate(input) {

    // new Date(null) is the epoch, so empty input must be rejected up front
    if (ValidateUtility.isEmpty(input)) return false

    return !Number.isNaN(new Date(input).getTime())
  }

  static isOptionalDate(input) {
    return ValidateUtility.isEmpty(input) || ValidateUtility.isDate(input)
  }

  static isAddrNo(input) {
    return /^\d+\s*(\/\s*\d+)?\s*(-\s*\d+)?$/gm.test(input)
  }

  static isEmail(input) {
    return /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/gm.test(input)
  }

  static isName(input) {
    return /^(?!\s+$|-|')[\p{L}\p{M}'\s.-]+$/u.test(input)
  }

  static isLatitude(input) {
    return (
      /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(input)
    )
  }

  static isLongitude(input) {
    return (
      /^[-+]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?)$/.test(input)
    )
  }

  static isURL(input) {
    return (
      /^(http|https)(:\/{2})([^\W+]\S+)$/.test(input)
    )
  }

  static isLocale(code, input) {

    // RegExp
    const regex = {
      chi: /^[\u4E00-\u9FFF\d\s.-]+$/gm,
      eng: /^[a-zA-Z\d\s.-]+$/gm,
      tha: /^[\u0E01-\u0E5B\d\s.-]+$/gm,
    }

    // Input Validator
    const tester = regex[code]

    return (
      tester ? tester.test(input) : false
    )
  }
}
